import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LabourMobilizationService, DeviationReportData, DeviationReportItem } from '../../shared/services/labour-mobilization.service';
import { ToastrMsgService } from '../../shared/services/shared-services/toastr.service';
import { ApiService } from '../../shared/services/api.service';

@Component({
  selector: 'app-deviation-report',
  templateUrl: './deviation-report.component.html',
  styleUrls: ['./deviation-report.component.css']
})
export class DeviationReportComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  reportData: DeviationReportData | null = null;
  reports: DeviationReportItem[] = [];
  loading = false;
  groupBy: 'date' | 'project' = 'date';
  
  selectedProject: string = '';
  startDate: string = '';
  endDate: string = '';
  projects: any[] = [];

  constructor(
    private labourService: LabourMobilizationService,
    private apiService: ApiService,
    private toastrMsgService: ToastrMsgService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadProjects();
    this.generateReport();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadProjects(): void {
    this.apiService.getProjectCommonAll({ limit: 1000 })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.projects = res.data || res || [];
        },
        error: (err) => {
          console.error('Error loading projects:', err);
        }
      });
  }

  generateReport(): void {
    this.loading = true;
    const params: any = {
      group_by: this.groupBy
    };
    
    if (this.selectedProject) params.project_id = this.selectedProject;
    if (this.startDate) params.start_date = this.startDate;
    if (this.endDate) params.end_date = this.endDate;

    this.labourService.getDeviationReport(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          this.reportData = response.data;
          this.reports = response.data.reports as DeviationReportItem[];
          this.loading = false;
        },
        error: (err) => {
          console.error('Error generating deviation report:', err);
          this.toastrMsgService.error(err.error?.message || 'Failed to generate deviation report');
          this.loading = false;
        }
      });
  }

  onGroupByChange(): void {
    this.generateReport();
  }

  onFilterChange(): void {
    this.generateReport();
  }

  formatDate(dateString: string): string {
    return this.labourService.formatDate(dateString);
  }

  getDeviationClass(deviation: number): string {
    if (deviation > 0) return 'deviation-excess';
    if (deviation < 0) return 'deviation-shortage';
    return 'deviation-match';
  }

  getDeviationIcon(deviation: number): string {
    if (deviation > 0) return 'trending_up';
    if (deviation < 0) return 'trending_down';
    return 'check_circle';
  }
}

